import { Button, Typography } from '@mui/material'
import { useOnboarding } from '../../context/OnboardingContext'
import { MISC_PRIMARY, MISC_PRIMARY_HOVER } from '../../theme/onboardingTheme'

type LicenseStatesIntroProps = {
  entityLabel: 'entities' | 'individuals'
}

export function LicenseStatesIntro({ entityLabel }: LicenseStatesIntroProps) {
  const { goToStep } = useOnboarding()

  return (
    <Typography component="p" sx={{ fontSize: 16, lineHeight: 1.625, color: '#1e293b' }}>
      MISC will run a report to pull the surplus lines licenses that you have indicated on the General
      Questions page for the {entityLabel} provided below. If you need to update the selected states,{' '}
      <Button
        type="button"
        onClick={() => goToStep('generalQuestions')}
        sx={{
          minWidth: 0,
          p: 0,
          verticalAlign: 'baseline',
          fontSize: 'inherit',
          fontWeight: 600,
          lineHeight: 'inherit',
          color: MISC_PRIMARY,
          textDecoration: 'underline',
          textTransform: 'none',
          '&:hover': { color: MISC_PRIMARY_HOVER, backgroundColor: 'transparent', textDecoration: 'underline' },
        }}
      >
        please click here
      </Button>
      .
    </Typography>
  )
}
